<script setup>
// Astra DS · BanderaIdioma — `Brand/Bandera 2827:445` (04.11.26).
//
// 🔴 **La marca del idioma, no un icono del sistema**: lleva su color propio,
// no pinta con `currentColor` y no está en `AstraIcon` (DESIGN.md § Las
// banderas · excepción declarada). Solo va en el selector de idioma y en su
// lista; no se usa para marcar contenidos ni países.
//
// 18 × 12, con un **filete exterior de 1 en `border/default`** para que el
// blanco de la francesa y la británica se lea sobre claro. En Figma es un trazo
// fuera de la caja; aquí, `outline`, que tampoco ocupa sitio. El color del
// filete sale del token y no del gris que trae el SVG exportado, que era el del
// modo claro.
//
// Los trazados, copiados del export de Figma: el inglés con la bandera del
// Reino Unido (decisión de Pablo, 04.11.26).
defineProps({
  idioma: {
    type: String,
    default: "es",
    validator: (v) => ["es", "en", "ca", "fr"].includes(v),
  },
});
</script>

<template>
  <svg
    class="bandera"
    width="18"
    height="12"
    viewBox="1 1 18 12"
    aria-hidden="true"
    focusable="false"
  >
    <template v-if="idioma === 'es'">
      <path d="M19 1H1V13H19V1Z" fill="#C60B1E" />
      <path d="M19 4H1V10H19V4Z" fill="#FFC400" />
    </template>
    <template v-else-if="idioma === 'en'">
      <path d="M19 1H1V13H19V1Z" fill="#012169" />
      <path d="M-2 1L22 13M22 1L-2 13" stroke-width="2.4" stroke="#FFFFFF" />
      <path d="M-2 1L22 13M22 1L-2 13" stroke-width="0.8" stroke="#C8102E" />
      <path d="M10 1V13M1 7H19" stroke-width="4" stroke="#FFFFFF" />
      <path d="M10 1V13M1 7H19" stroke-width="2.4" stroke="#C8102E" />
    </template>
    <template v-else-if="idioma === 'ca'">
      <path d="M19 1H1V13H19V1Z" fill="#FCDD09" />
      <path d="M19 2.333H1V3.666H19V2.333Z" fill="#DA121A" />
      <path d="M19 5H1V6.333H19V5Z" fill="#DA121A" />
      <path d="M19 7.667H1V9H19V7.667Z" fill="#DA121A" />
      <path d="M19 10.333H1V11.666H19V10.333Z" fill="#DA121A" />
    </template>
    <template v-else>
      <path d="M7 1H1V13H7V1Z" fill="#002654" />
      <path d="M13 1H7V13H13V1Z" fill="#FFFFFF" />
      <path d="M19 1H13V13H19V1Z" fill="#CE1126" />
    </template>
  </svg>
</template>

<style scoped>
.bandera {
  display: block;
  flex: none;
  width: 18px;
  height: 12px;
  overflow: hidden;
  outline: 1px solid var(--color-border-default);
}
</style>
